/**
 * 成功
 * 2017-12-6
 */
"use strict";
angular.module("successModule", [
    'successRouter',
]).
controller("successCtrl", ["$scope","$state", function($scope,$state) {
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化参数
     */
    function initStatus() {
        $scope.status = {

        };
        $scope.data = {
            listData: [],
        };
        $scope.page = {
            CURRPAGE: 1,
            PAGESIZE: 12,
            PAGECOUNT: 1,
            ITEMCOUNT: 0
        };
    }
    /**
     * [initStatus description] 初始化数据
     */
    function initData() {

    }

    /**
     * [homePage description] 进入首页
     */
    $scope.homePage = function(){
        var url = $state.href("index.homepage");
        window.open(url,"_self");
    }
}]);